
import React from 'react'
import Page from '../components/Page'

export default class extends React.Component {
  render() {
    return (
      <Page title="Recycling Recipes">
        <p>2 Quivers of Bolts --> 1 Quiver of Arrows (random quantity)</p>
        <p>2 Quivers of Arrows --> 1 Quiver of Bolts (random quantity)</p>
        <p>1 Spear + 1 Quiver of Arrows --> 1 Stack of Javelins (non-magical, random quantity)</p>
        <p>1 Axe + 1 Dagger --> A stack of throwing axes (non-magical, random quantity)</p>
        <p>1 Strangling Gas Potion + 1 Healing Potion --> 1 Antidote Potion</p>
        <p>3 Magic Amulets --> 1 Magic Ring</p>
        <p>3 Magic Rings --> 1 Random Magic Amulet</p>
        <p>6 Perfect Skulls + 1 Rare Item --> 1 Random Low Quality Rare Item of the same type</p>
        <p>1 Perfect Skull + 1 Rare Item + Stone of Jordan --> 1 High Quality New Rare Item of the same type</p>
        <p>3 Perfect Gems (of any type, including Skulls) + 1 Magic Item --> 1 New Random Magic Item of the Same Type</p>
      </Page>
    )
  }
}